// extracted by mini-css-extract-plugin
export default {"item":"styles_item__5j7UJ","key":"styles_key__ZmN7h","value":"styles_value__9Uon6"};